// https://faq.whatsapp.com/general/chats/how-to-use-click-to-chat/?lang=nl
// According to the whatsapp documentation they don't allow the characters + - or space in the phone numbe.

export const whatsappFriendlyPhone = (phone: string): string => {
  return phone.replace(/-|\+| /g, '')
}

export const isMobileNumber = (phone: string): boolean => {
  phone = phone.replace(/ /g, '') //clean up all spaces
  return phone.startsWith('+316') || phone.startsWith('6') || phone.startsWith('06')
}
